<template>
  <div class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end form-offcanvas" tabindex="-1" id="offcanvas"
    ref="offcanvas" data-bs-backdrop="static">
    <!-- data-bs-backdrop="static" -->
    <div class="offcanvas-header border-bottom bg-white py-3">
      <h6 class="offcanvas-title fw-bold mb-0 d-flex align-items-center gap-2">
        <i class="fa-solid fa-box-open text-theme" />
        {{ type === 'CREATE' ? $t('Create Product') : $t('Edit Product') }}
      </h6>
      <button type="button" style="font-size: small;" class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas" aria-label="Close" />
    </div>

    <div class="offcanvas-body" v-if="loading">
      <placeholder-content :is-load="true" />
    </div>
    <div class="offcanvas-body" v-else-if="!hasPermission">
      <access-denied />
    </div>
    <div class="offcanvas-body bg-body-secondary p-3" v-else>
      <section v-show="currentStep == 1">
        <!-- ───── หมวด 1: ข้อมูลสินค้า ───── -->
        <div class="form-card">
          <div class="form-section-header">
            <i class="fa-solid fa-circle-info" />
            <span>{{ $t('Product Information') }}</span>
          </div>
          <div class="px-3">
            <div class="row g-3 py-2">
              <div class="col-md-4">
                <label for="name" class="form-label">
                  {{ $t('Name (TH)') }}
                  <span class="text-danger">*</span>
                </label>
                <div class="input-group-sm">
                  <input id="name" type="text" v-model.trim="v$.form.name.$model" class="form-control shadow-none"
                    :placeholder="$t('Enter product name') + '...'">
                  <div v-for="error of v$.form.name.$errors" class="d-block invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="name_en" class="form-label">
                  {{ $t('Name (EN)') }}
                </label>
                <div class="input-group-sm">
                  <input id="name_en" type="text" v-model.trim="v$.form.name_en.$model"
                    class="form-control shadow-none" :placeholder="$t('Enter product name in English') + '...'">
                  <div class="form-text text-muted">{{ $t('Leave blank to show the Thai name.') }}</div>
                  <div v-for="error of v$.form.name_en.$errors" class="d-block invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="type" class="form-label">
                  {{ $t('Type') }}
                  <span class="text-danger">*</span>
                </label>
                <select2 v-model.trim="v$.form.is_config.$model" @select="() => {
                  form.price = '';
                }" :options="select2FormType.options" :settings="select2FormType.setting"
                  :disabled="type === 'EDIT'" />
              </div>
              <div class="col-md-4">
                <label for="Category" class="form-label">
                  {{ $t('Category') }}
                  <span class="text-danger">*</span>
                </label>
                <select2 :disabled="isVariant" v-model.trim="v$.form.product_category_id.$model"
                  :options="select2FormCategory.options" :settings="select2FormCategory.setting" />
              </div>
              <div class="col-md-4">
                <label for="code" class="form-label">
                  {{ $t('SKU') }}
                </label>
                <div class="input-group input-group-sm">
                  <input id="code" type="text" v-model.trim="v$.form.code.$model" class="form-control shadow-none"
                    :placeholder="$t('Enter product sku') + '...'">
                  <button class="input-group-text" @click="generateBarcode('sku')">
                    <i class="fa-solid fa-rotate" />
                  </button>
                  <div v-for="error of v$.form.code.$errors" class="d-block invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="barcode" class="form-label">
                  {{ $t('Barcode') }}
                  <span class="text-danger">*</span>
                </label>
                <div class="input-group input-group-sm">
                  <input id="barcode" type="text" v-model.trim="v$.form.barcode.$model" class="form-control shadow-none"
                    :placeholder="$t('Enter product barcode') + '...'">
                  <button class="input-group-text" @click="generateBarcode()">
                    <i class="fa-solid fa-rotate" />
                  </button>
                  <div v-for="error of v$.form.barcode.$errors" class="d-block invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label" for="flexSwitchCheckStatus">
                  {{ $t('Status') }}
                </label>
                <div class="form-check form-switch">
                  <input class="form-check-input shadow-none" type="checkbox" id="flexSwitchCheckStatus"
                    v-model.trim="v$.form.is_active.$model">
                  <label class="form-check-label" for="flexSwitchCheckStatus">
                    {{ $t('Active') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ───── หมวด 2: รูปภาพ & รายละเอียด ───── -->
        <div class="form-card">
          <div class="form-section-header">
            <i class="fa-solid fa-image" />
            <span>{{ $t('Media & Description') }}</span>
          </div>
          <div class="px-3">
            <div class="row g-3 py-2">
              <div class="col-md-6">
                <label for="images" class="form-label">{{ $t('Media') }}</label>
                <vue-upload-multiple-image @upload-success="uploadImageSuccess" @before-remove="beforeRemove"
                  @edit-image="editImage" @limit-exceeded="limitExceeded" :multiple="false" :data-images="images"
                  :max-image="image.maxImage" :show-primary="image.showPrimary" :show-edit="image.showEdit"
                  id-upload="myIdUpload" edit-upload="myIdEdit" :drag-text="$t('Drage Image')"
                  :browse-text="$t('Browse Image')" primary-text="Base image" mark-is-primary-text="Set base image"
                  popup-text="default base image" :drop-text="$t('Drag and drop')" />
                <span class="form-text text-muted">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                    <path
                      d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z">
                    </path>
                  </svg>
                  {{ this.maxUploadImg }}
                </span>
                <div v-for="error of apiErrors.image" class="d-block invalid-feedback" :key="error">
                  {{ $t(error) }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="description" class="form-label">{{ $t('Description (TH)') }}</label>
                <vue-editor v-model="v$.form.description.$model" :editor-toolbar="editor.toolbar"
                  :placeholder="$t('Enter description') + '...'"
                  :class="v$.form.description.$error ? 'is-invalid' : ''" />
                <div v-for="error of v$.form.description.$errors" class="invalid-feedback" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="description_en" class="form-label">{{ $t('Description (EN)') }}</label>
                <vue-editor v-model="v$.form.description_en.$model" :editor-toolbar="editor.toolbar"
                  :placeholder="$t('Enter description in English') + '...'"
                  :class="v$.form.description_en.$error ? 'is-invalid' : ''" />
                <div class="form-text text-muted">{{ $t('Leave blank to show the Thai description.') }}</div>
                <div v-for="error of v$.form.description_en.$errors" class="invalid-feedback" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ───── หมวด 3: ราคา & หน่วยนับ ───── -->
        <div class="form-card">
          <div class="form-section-header">
            <i class="fa-solid fa-tag" />
            <span>{{ $t('Pricing & Portions') }}</span>
          </div>
          <div class="px-3">
            <div class="row g-3 py-2">
              <div class="col-md-3">
                <label for="price" class="form-label">
                  {{ $t('Price') }}
                  <span class="text-danger" v-if="form.is_config == 0">
                    *
                  </span>
                </label>
                <div class="custom-input-group custom-input-group input-group input-group-sm">
                  <input id="price" type="number" inputmode="decimal" v-model.trim="v$.form.price.$model"
                    class="form-control shadow-none" :class="v$.form.price.$error ? 'is-invalid' : ''"
                    :placeholder="$t('Enter price') + '...'">
                  <span class="input-group-text">
                    {{ $t('฿') }}
                  </span>
                  <div v-for="error of v$.form.price.$errors" class="invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="compare_at_price" class="form-label">
                  {{ $t('Compare at price') }}
                </label>
                <div class="custom-input-group custom-input-group input-group input-group-sm">
                  <input id="compare_at_price" type="number" inputmode="decimal"
                    v-model.trim="v$.form.compare_at_price.$model" class="form-control shadow-none"
                    :class="v$.form.compare_at_price.$error ? 'is-invalid' : ''"
                    :placeholder="$t('Compare at price') + '...'">
                  <span class="input-group-text">
                    {{ $t('฿') }}
                  </span>
                  <div v-for="error of v$.form.compare_at_price.$errors" class="invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
                <small class="text-secondary">
                  {{ $t('Shown crossed out next to the selling price. Must be higher than price.') }}
                </small>
              </div>
              <div class="col-md-3">
                <label for="cost" class="form-label">
                  {{ $t('Cost') }}
                </label>
                <div class="input-group input-group-sm me-1">
                  <input id="cost" type="number" inputmode="decimal" v-model.trim="v$.form.cost_manual.$model"
                    class="form-control shadow-none" :class="v$.form.cost_manual.$error ? 'is-invalid' : ''"
                    :placeholder="form.cost_estimate || ($t('Enter cost') + '...')" :disabled="form.is_config">
                  <span class="input-group-text">
                    {{ $t('฿') }}
                  </span>
                  <div v-for="error of v$.form.cost_manual.$errors" class="invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="Tax" class="form-label">
                  {{ $t('Tax Status') }}
                  <span class="text-danger">*</span>
                </label>
                <select2 v-model.trim="v$.form.tax_status.$model" :options="select2FormTaxStatus.options"
                  :settings="select2FormTaxStatus.setting" :disabled="isVariant" />
              </div>
              <div class="col-md-3">
                <label for="servingSize" class="form-label">
                  {{ $t('Serving Size') }}
                </label>
                <div class="input-group input-group-sm">
                  <input id="servingSize" type="number" inputmode="numeric"
                    v-model.trim="v$.form.serving_size_value.$model" class="form-control shadow-none w-25"
                    :placeholder="$t('Enter serving size') + '...'">
                  <select class="form-select shadow-none" v-model.trim="v$.form.serving_size_unit_id.$model"
                    style="text-transform: capitalize" :placeholder="$t('Select serving size') + '...'">
                    <option v-for="unit in selectOptionServingSizeUnits" :value="unit.id"
                      style="text-transform: capitalize">
                      {{ unit.text }}
                    </option>
                  </select>
                  <div v-for="error of v$.form.serving_size_value.$errors" class="d-block invalid-feedback"
                    :key="error.$uid">
                    {{ error.$message }}
                  </div>
                  <div v-for="error of v$.form.serving_size_unit_id.$errors" class="d-block invalid-feedback"
                    :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label for="Tax" class="form-label">
                  {{ $t('Main Unit') }}
                </label>
                <select2 v-model.trim="v$.form.unit_id.$model" :options="select2FormUnit.options"
                  :settings="select2FormUnit.setting" />
              </div>
            </div>
          </div>
        </div>

        <!-- ───── หมวด 4: ตัวเลือกการแสดงผล ───── -->
        <template v-if="!isVariant">
          <div class="form-card">
            <div class="form-section-header">
              <i class="fa-solid fa-eye" />
              <span>{{ $t('Display Options') }}</span>
            </div>
            <div class="px-3">
              <div class="row g-3 py-2">
                <div class="col-md-4">
                  <label class="option-card h-100" :class="{ 'is-checked': form.reward_only }">
                    <div class="form-check mb-0">
                      <input class="form-check-input shadow-none" v-model="form.reward_only" type="checkbox"
                        id="checkRewardOnly">
                      <span class="form-check-label fw-medium">
                        🎁 {{ $t('Reward-only product') }}
                      </span>
                    </div>
                    <div class="text-secondary small mt-1">
                      {{ $t('Hidden from sales menu — customers get it via promotion/loyalty only.') }}
                    </div>
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="option-card h-100" :class="{ 'is-checked': form.is_recommend }">
                    <div class="form-check mb-0">
                      <input class="form-check-input shadow-none" v-model.trim="v$.form.is_recommend.$model"
                        type="checkbox" id="checkRecommend">
                      <span class="form-check-label fw-medium">
                        ⭐ {{ $t('Recommend this Product') }}
                      </span>
                    </div>
                    <div class="text-secondary small mt-1">
                      {{ $t('Show in "Recommended" section on menu.') }}
                    </div>
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="option-card h-100" :class="{ 'is-checked': form.dine_in_only }">
                    <div class="form-check mb-0">
                      <input class="form-check-input shadow-none" v-model.trim="v$.form.dine_in_only.$model"
                        @change="applyDineInOnlyToVariants" type="checkbox" id="checkDineInOnly">
                      <span class="form-check-label fw-medium">
                        🍽️ {{ $t('Dine-in only') }}
                      </span>
                    </div>
                    <div class="text-secondary small mt-1">
                      {{ $t('Cannot be ordered for takeaway or delivery.') }}
                    </div>
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="option-card h-100" :class="{ 'is-checked': form.pos_only }">
                    <div class="form-check mb-0">
                      <input class="form-check-input shadow-none" v-model.trim="v$.form.pos_only.$model"
                        type="checkbox" id="checkPosOnly">
                      <span class="form-check-label fw-medium">
                        🧑‍🍳 {{ $t('POS staff only') }}
                      </span>
                    </div>
                    <div class="text-secondary small mt-1">
                      {{ $t('Sold only at the staff POS — hidden from the customer QR self-order menu.') }}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </template>
      </section>

      <section v-show="currentStep == 2" class="my-0">
        <div class="form-card">
          <div class="form-section-header">
            <i class="fa-solid fa-sliders" />
            <span>{{ $t('Attributes & Options') }}</span>
          </div>
          <div class="px-3">
            <div class="row g-3 py-2">
              <template v-for="(attribute, index) in form.attributes">
                <attribute-form :attribute="attribute" :index="index" @update-variants="updateVariants"
                  @remove-attribute-variants="removeAttributeVariants" />
              </template>
              <div class="col-md-4 mt-1">
                <ladda
                  :text="$t('Add Attribute') + ' ' + ' (' + form.attributes.length + '/' + v$.form.attributes.maxLength.$params.max + ')'"
                  :btn-class="'btn btn-theme btn-block '" icon="<i class='fa-solid fa-plus' /i>"
                  :disabled="(form.attributes.length >= v$.form.attributes.maxLength.$params.max || inValidFormAttribute)"
                  @click="addAttribte" />
              </div>
              <!-- <div class="col-md-3">
              <label
                class="form-label"
              >
                {{ $t('Attribute') + form.a }}
              </label>
              <select2
                v-model.trim="v$.form.tax_status.$model"
                :options="select2FormTaxStatus.options"
                :settings="select2FormTaxStatus.setting"
              />
            </div> -->
            </div>
          </div>
        </div>
        <div class="form-card">
          <div class="form-section-header">
            <i class="fa-solid fa-layer-group" />
            <span>{{ $t('Variants') }}</span>
          </div>
          <div class="px-3 pt-3">
            <div class="overflow-x-auto border rounded">
              <table class="table table-sm variant-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th class="text-end" style="min-width: 25px;max-width: 25px;width: 25px;">
                      #
                    </th>
                    <th style="min-width: 100px;">
                      {{ $t('Name') }}
                    </th>
                    <th class="text-end" style="min-width: 150px;max-width: 150px;width: 150px;">
                      {{ $t('Price') }}
                    </th>
                    <th class="text-end" style="min-width: 150px;max-width: 150px;width: 150px;">
                      {{ $t('Compare at price') }}
                    </th>
                    <th class="text-end" style="min-width: 150px;max-width: 150px;width: 150px;">
                      {{ $t('Cost') }}
                    </th>
                    <th style="min-width: 200px;max-width: 200px;width: 200px;">
                      {{ $t('SKU') }}
                    </th>
                    <th style="min-width: 100px;max-width: 100px;width: 100px;">
                      {{ $t('Status') }}
                    </th>
                    <th style="min-width: 80px;max-width: 80px;width: 80px;">
                      {{ $t('Action') }}
                    </th>
                  </tr>
                </thead>
                <tbody class="align-baseline">
                  <template v-for="(varian, index) in form.variants">
                    <variant-form :variant="varian" :index="index" :units="select2FormUnit.options" />
                  </template>
                  <tr v-if="form.variants.length == 0">
                    <td colspan="8" class="text-center">
                      {{ $t('No Available Data') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="bg-light border-top justify-content-center modal-footer py-2" v-if="!loading && hasPermission">
      <ladda text="Previous" :btn-class="'btn btn-secondary btn-sm btn-block me-2'"
        icon="<i class='fas fa-arrow-circle-left'></i>" @click="prevStep" v-if="currentStep != 1" />
      <ladda text="Next Step: Configure Variants" v-if="form.is_config == 1 && currentStep == 1"
        :btn-class="'btn btn-theme btn-block me-2'" :loading="loadingSave" :disabled="v$.form.name.$invalid ||
          v$.form.product_category_id.$invalid ||
          v$.form.code.$invalid ||
          v$.form.barcode.$invalid ||
          v$.form.name_en.$invalid ||
          v$.form.description.$invalid ||
          v$.form.description_en.$invalid ||
          v$.form.price.$invalid ||
          v$.form.compare_at_price.$invalid ||
          v$.form.tax_status.$invalid ||
          v$.form.image.$invalid ||
          v$.form.is_active.$invalid ||
          v$.form.is_recommend.$invalid ||
          v$.form.is_config.$invalid ||
          v$.form.serving_size_value.$invalid ||
          v$.form.serving_size_unit_id.$invalid ||
          v$.form.unit_id.$invalid
          " @click="nextStep" />
      <ladda text="Save" v-if="type === 'CREATE' && (form.is_config == 0 || currentStep == 2)"
        :btn-class="'btn btn-theme btn-block me-2'" :loading="loadingSave" :disabled="v$.$invalid"
        @click="handleCreate" />
      <ladda text="Save" v-if="type === 'EDIT' && (form.is_config == 0 || currentStep == 2)"
        :btn-class="'btn btn-theme btn-block me-2'" :loading="loadingSave" :disabled="v$.$invalid"
        @click="handleUpdate" />
      <button type="button" data-bs-dismiss="offcanvas" class="border-dark-subtle btn-sm btn btn-light me-2">
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Select2 from 'vue3-select2-component';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { Products } from '@/services/endpoint/products.service';
import AttributeForm from './AttributeForm.vue';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import Ladda from '@/plugins/Ladda.vue';
import numeral from 'numeral';
import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue';
import { VueEditor } from "vue3-editor";
import VariantForm from './VariantForm.vue';
import moment from "moment";
import _ from 'lodash';
import { handleVariantChange, handleAttributeRemoval } from '@/utils/variantManager';
import { randomString } from '@/utils/helpers';
import { apiErrorText } from '@/utils/apiError';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.form);
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    let vm = this;
    return {
      loading: true,
      loadingSave: false,
      image: {
        maxImage: 1,
        maxSize: 5,
        showPrimary: false,
        showEdit: false
      },
      inValidFormAttribute: true,
      // คำบรรยายสินค้าไปโผล่บนเมนู POS / ลูกค้า ซึ่งแสดงเป็น "ข้อความล้วน"
      // (API ถอดแท็กก่อนส่ง) — หัวข้อ/จัดหน้า/สี จึงไม่มีผลอะไรกับหน้าเมนู
      // เหลือไว้แค่เน้นคำกับลิสต์ ให้คนกรอกไม่ต้องเสียเวลาแต่งข้อความเกินจำเป็น
      editor: {
        toolbar: [
          ["bold", "italic", "underline"],
          ["clean"],
        ],
      },
      hasPermission: false,
      // error ราย field จาก API (code = VALIDATION) — เก็บไว้โชว์ติดช่องที่พัง
      // ที่ต้องมีเพราะ v$ (vuelidate) เช็กได้แค่ฝั่ง FE ส่วนรูปภาพ BE เป็นคนตัดสินว่าอ่านไฟล์ได้ไหม
      apiErrors: {},
      images: [],
      form: {
        name: '',
        name_en: '',
        product_category_id: 1,
        code: '',
        barcode: randomString(10),
        description: '',
        description_en: '',
        price: '',
        compare_at_price: '',
        tax_status: 'vatable',
        image: '',
        is_active: true,
        is_recommend: false,
        dine_in_only: false,
        pos_only: false,
        reward_only: false,
        is_config: 0,
        serving_size_value: '',
        serving_size_unit_id: '',
        unit_id: '',
        attributes: [],
        variants: []
      },
      selectOptionServingSizeUnits: [],
      select2FormUnit: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
          placeholder: vm.$t('Select') + '...',
          allowClear: true
        }
      },
      select2FormTaxStatus: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormCategory: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2FormType: {
        options: [
          {
            id: 0,
            text: this.$t('Simple')
          },
          {
            id: 1,
            text: this.$t('Configurale')
          }
        ],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      isVariant: false,
      currentStep: 1,
      stepConfigurales: [
        { id: 1, title: 'Create Product Configurale' },
        { id: 2, title: 'Set Configure Variants' }
      ],
    }
  },
  components: {
    Select2,
    PlaceholderContent,
    Ladda,
    VueUploadMultipleImage,
    VueEditor,
    AccessDenied,
    AttributeForm,
    VariantForm
  },
  methods: {
    // parent checkbox = ปิด/เปิด "ทานที่ร้านเท่านั้น" ให้ทุก variant ทีเดียว (config)
    // หลังจากนี้ยังปรับราย variant เองได้ การบังคับใช้จริงอิงค่าราย variant
    applyDineInOnlyToVariants() {
      if (this.form.is_config == 1) {
        this.form.variants.forEach((v) => {
          v.dine_in_only = this.form.dine_in_only;
        });
      }
    },
    async updateVariants(data) {
      try {
        this.form.variants = handleVariantChange(
          this.form.variants,
          data,
          this.form.name,
          this.form.code,
          this.form.serving_size_unit_id,
          this.form.unit_id,
          this.form.name_en
        );
      } catch (error) {
      }
    },
    // จัดการเมื่อเปลี่ยน Attribute ตัวแม่ (ล้าง Variants เก่าทิ้ง)
    async removeAttributeVariants(attributeId) {
      this.form.variants = handleAttributeRemoval(
        this.form.variants,
        attributeId,
        this.form.name,
        this.form.code,
        this.form.serving_size_unit_id,
        this.form.unit_id,
        this.form.name_en
      );
    },
    async deleteItem(index) {
      const attributeIdToRemove = this.form.attributes[index].id;
      if (attributeIdToRemove) {
        this.removeAttributeVariants(attributeIdToRemove);
      }
      this.form.attributes.splice(index, 1);
    },
    nextStep() {
      if (this.currentStep < this.stepConfigurales.length) this.currentStep++;
      if (this.form.attributes.length == 0) this.form.attributes = [{
        id: '',
        option_ids: []
      }]
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    addAttribte() {
      this.inValidFormAttribute = true;
      this.form.attributes.push({
        id: '',
        option_ids: []
      });
    },
    generateBarcode(type = 'barcode') {
      type === 'sku' ? this.form.code = this.form.barcode = randomString(10) : this.form.barcode = randomString(10);
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    addUnit() {
      this.form.unit_conversions.push({
        unit_id: 0,
        conversion_factor: ''
      });
    },
    deleteUnit(index) {
      this.form.unit_conversions.splice(index, 1);
    },
    uploadImageSuccess(formData, index, fileList, fileSize) {
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.image.maxImage || imgSize > this.image.maxSize) {
        imgList.splice(index, 1);
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
        return;
      }
      this.images = imgList;
      this.form.image = imgList[0].path;
    },
    beforeRemove(index, done, fileList, mediaId) {
      if (mediaId) this.form.remove_image = mediaId;
      done();
      this.images = fileList;
      this.form.image = '';
    },
    editImage(formData, index, fileList) {
      // "แก้รูป" = ทับรูปเดิม → ต้องส่ง remove_image ของเก่าไปด้วย
      // ไม่งั้น media เดิมยัง status=1 ค้างคู่กับรูปใหม่ = ไฟล์ค้างบนดิสก์ + หน้าเมนูอาจโชว์รูปเก่า
      const current = fileList[index];
      if (current?.id) this.form.remove_image = current.id;
      this.images = fileList;
      this.form.image = current.path;
    },
    limitExceeded(limit) {
      this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
    },
    async getCreateData() {
      await Products.getCreate().then(res => {
        this.select2FormCategory.options = res.data.data.categories.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.form.product_category_id = res.data.data.categories[0].id;
        this.select2FormTaxStatus.options = res.data.data.tax_status.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });

        this.select2FormUnit.options = res.data.data.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.selectOptionServingSizeUnits = [...[{
          id: '',
          text: this.$t('Select') + '...'
        }], ...res.data.data.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        })];
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
        throw err;
      });
    },
    async getUpdateData() {
      await Products.getUpdate(this.id).then(res => {
        this.select2FormCategory.options = res.data.filter.categories.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.select2FormTaxStatus.options = res.data.filter.tax_status.map(v => {
          return {
            id: v.value,
            text: this.$t(v.text)
          }
        });

        this.select2FormUnit.options = res.data.filter.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        });
        this.selectOptionServingSizeUnits = [...[{
          id: '',
          text: this.$t('Select') + '...'
        }], ...res.data.filter.units.map(v => {
          return {
            id: v.id,
            text: this.$t(v.name)
          }
        })];

        this.isVariant = res.data.data.variant;
        this.form.name = res.data.data.name;
        this.form.name_en = res.data.data.name_en;
        this.form.product_category_id = res.data.data.product_category_id;
        this.form.code = res.data.data.code;
        this.form.barcode = res.data.data.barcode;
        this.form.description = res.data.data.description;
        this.form.description_en = res.data.data.description_en;
        this.form.price = res.data.data.price;
        this.form.compare_at_price = res.data.data.compare_at_price;
        this.form.cost_estimate = res.data.data.cost_estimate;
        this.form.cost_manual = res.data.data.cost_manual;
        this.form.tax_status = res.data.data.tax_status;
        this.form.is_active = res.data.data.active;
        this.form.is_recommend = res.data.data.recommend;
        this.form.dine_in_only = res.data.data.dine_in_only;
        this.form.pos_only = res.data.data.pos_only;
        this.form.reward_only = res.data.data.show_in_menu === false;
        this.form.is_config = res.data.data.config ? 1 : 0;
        this.form.serving_size_value = res.data.data.size_value;
        this.form.serving_size_unit_id = res.data.data.size_unit_id;
        this.form.unit_id = res.data.data.unit_id;
        this.form.attributes = res.data.data.attributes;

        if (this.form.attributes.length < this.v$.form.attributes.maxLength.$params.max) this.inValidFormAttribute = false;
        this.form.variants = res.data.data.variants.map(function (variant) {
          return {
            id: variant.id,
            code: variant.code,
            barcode: variant.barcode,
            name: variant.name,
            name_en: variant.name_en,
            description: variant.description,
            description_en: variant.description_en,
            price: variant.price,
            compare_at_price: variant.compare_at_price,
            cost_manual: variant.cost_manual,
            cost_estimate: variant.cost_estimate,
            is_active: variant.active,
            dine_in_only: variant.dine_in_only,
            serving_size_value: variant.size_value,
            serving_size_unit_id: variant.size_unit_id,
            unit_id: variant.unit_id,
            attributes: variant.attributes,
            images: variant.images
          }
        })

        this.images = res.data.data.images.map((v, k) => {
          return {
            id: v.id,
            default: 1,
            highlight: k == 0 ? 1 : 0,
            name: v.file_name,
            path: v.image_url,
            type: 'old'
          }
        });
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
        throw err;
      });
    },
    // ฟิลด์ EN เป็น optional — ต้องส่ง null ไปด้วยตอนล้างค่า ไม่งั้น key ถูกตัดทิ้ง
    // ตาม rule "ค่าว่าง = ไม่ส่ง" ด้านบน แล้ว API จะมองว่าไม่ได้แก้ = ค่าเดิมค้างอยู่
    setBilingualParams(params) {
      params.name_en = this.form.name_en || null;
      params.description_en = this.form.description_en || null;
      if (params.variants) {
        params.variants = params.variants.map(variant => ({
          ...variant,
          name_en: variant.name_en || null,
          description_en: variant.description_en || null
        }));
      }
      return params;
    },
    setParamsBeforeSendCreate() {
      let params = _.cloneDeep(this.form);
      // checkbox ฝั่งฟอร์มคือ "เป็นของแถม/ของสะสม" — DB เก็บมุมกลับ show_in_menu
      params.show_in_menu = !params.reward_only;
      delete params.reward_only;
      delete params.cost_estimate;
      if (!params.is_config) {
        delete params.attributes;
        delete params.variants;
      }
      $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
      return this.setBilingualParams(params);
    },
    setParamsBeforeSendUpdate() {
      let params = _.cloneDeep(this.form);
      params.show_in_menu = !params.reward_only;
      delete params.reward_only;
      delete params.cost_estimate;
      if (!params.is_config) {
        delete params.attributes;
        delete params.variants;
      }
      $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
      return this.setBilingualParams(params);
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Products.create(this.setParamsBeforeSendCreate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        this.apiErrors = err?.response?.data?.errors ?? {};
        const detail = apiErrorText(err, (key) => this.$t(key));
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Save Failed!') + (detail ? "\n" + detail : ''));
        this.loadingSave = false;
      });
    },
    async handleUpdate() {
      this.loadingSave = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Products.update(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        this.apiErrors = err?.response?.data?.errors ?? {};
        const detail = apiErrorText(err, (key) => this.$t(key));
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Save Failed!') + (detail ? "\n" + detail : ''));
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas', async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFrom.open = false;
    });
  },
  computed: {
    maxUploadImg: function () {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
  },
  watch: {
    // 'form.lots': {
    //   handler() {
    //     this.form.quantity = this.calculateQuantity;
    //     this.form.cost = this.calculateCost;
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
}
</script>
